<template>
    <div>
        <h1>
            {{
                $store.state.language.layout.bread_crumbs.customer_register_list
            }}
        </h1>
        <div class="mb-3 d-flex flex-wrap align-items-center gap-3">
            <div>
                <label class="me-2">{{ $store.state.language.agent.list_column.status }}:</label>
                <select class="form-select form-select-sm d-inline-block w-auto" v-model="select.status">
                    <option value="all">{{ $store.state.language.agent.list_filter_all }}</option>
                    <option value="pass">{{ $store.state.language.agent.list_filter_pass }}</option>
                    <option value="send">{{ $store.state.language.agent.flow_send }}</option>
                    <option value="expire">{{ $store.state.language.agent.flow_expire }}</option>
                    <option value="reject">{{ $store.state.language.agent.flow_reject }}</option>
                </select>
            </div>
            <div>
                <label class="me-2">{{ $store.state.language.agent.list_column.company_name }}:</label>
                <input
                    type="text"
                    class="form-control form-control-sm d-inline-block w-auto"
                    style="min-width: 12em;"
                    v-model.trim="select.company"
                    :placeholder="$store.state.language.agent.list_filter_company_placeholder"
                />
            </div>
        </div>
        <div style="width: 100%;overflow: auto;">
            <table class="table" style="width: 100%;">
                <thead>
                    <tr>
                        <th style="width: 3em;">#</th>
                        <th style="width: 8em;">
                            {{ $store.state.language.agent.list_column.ctime }}
                        </th>
                        <th style="width: 15em;">
                            {{
                                $store.state.language.agent.list_column
                                    .company_name
                            }}
                        </th>
                        <th style="width: 15em;">
                            {{
                                $store.state.language.agent.list_column
                                    .required_model
                            }}
                        </th>
                        <th>
                            {{ $store.state.language.agent.list_column.status }}
                        </th>
                        <th>
                            {{ $store.state.language.agent.list_column.action }}
                        </th>
                    </tr>
                </thead>
                <tbody v-for="(d, dk) in dataFilterList" :key="d.id">
                    <tr @click="d.show_detail = !d.show_detail">
                        <td>{{ dk + 1 }}</td>
                        <td v-html="d.ctime.replace(' ', '<br />')"></td>
                        <td>{{ d.company_name }}</td>
                        <td>{{ d.required_model }}</td>
                        <td>
                            <div>
                                <span
                                    class="badge bg-danger"
                                    v-if="d.flow_status == 'reject'"
                                    :title="
                                        d.flow_var['reply_status'] ==
                                        'supplementary_data'
                                            ? $store.state.language.agent
                                                  .flow_reject_resend
                                            : $store.state.language.agent
                                                  .flow_reject_full
                                    "
                                >
                                    <i class="fa fa-times"></i>
                                    {{
                                        $store.state.language.agent.flow_reject
                                    }}
                                </span>
                                <span
                                    class="badge bg-warning"
                                    v-else-if="d.flow_status == 'send'"
                                    :title="
                                        $store.state.language.agent
                                            .flow_send_full
                                    "
                                >
                                    <i class="far fa-paper-plane"></i>
                                    {{ $store.state.language.agent.flow_send }}
                                </span>
                                <span
                                    class="badge bg-success"
                                    v-else-if="
                                        d.flow_status == 'pass' &&
                                            d.status < 990
                                    "
                                    :title="
                                        $store.state.language.agent[
                                            `flow_pass_${d.status}_full`
                                        ]
                                    "
                                >
                                    <i class="fa fa-check"></i>
                                    {{
                                        $store.state.language.agent[
                                            `flow_pass_${d.status}`
                                        ]
                                    }}
                                </span>
                                <span
                                    class="badge bg-secondary"
                                    v-else-if="d.status >= 990"
                                >
                                    <i class="far fa-hand-paper"></i>
                                    {{
                                        $store.state.language.agent.flow_expire
                                    }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <router-link
                                class="btn btn-outline-primary btn-sm py-0"
                                v-if="
                                    d.flow_status == 'reject' &&
                                        d.status == '0' &&
                                        d.flow_var['reply_status'] ==
                                            'supplementary_data'
                                "
                                :to="`/agent/customer_register/${d.id}/edit`"
                            >
                                <i class="fa fa-pen"></i>
                                {{ $store.state.language.agent.flow_edit }}
                            </router-link>
                            <router-link
                                class="btn btn-outline-primary btn-sm py-0"
                                :to="`/agent/customer_register/${d.id}/update`"
                                v-if="
                                    d.status == '1' && d.flow_status != 'send'
                                "
                            >
                                <i class="fa fa-pen"></i>
                                {{ $store.state.language.agent.case_update }}
                            </router-link>
                        </td>
                    </tr>
                    <transition name="fade">
                        <tr v-show="d.show_detail">
                            <td colspan="6">
                                <div class="row m-0">
                                    <div
                                        class="col-md-12"
                                        v-if="d.flow_status == 'reject'"
                                    >
                                        <div
                                            style="background-color: #FED;padding: 5px 10px;font-size: 15px"
                                        >
                                            {{
                                                d.flow_var["reply_status"] ==
                                                "supplementary_data"
                                                    ? $store.state.language
                                                          .agent
                                                          .flow_reject_resend
                                                    : $store.state.language
                                                          .agent
                                                          .flow_reject_full
                                            }}
                                            <div
                                                v-if="
                                                    d.last_flow &&
                                                        d.last_flow.reply
                                                "
                                            >
                                                {{ d.last_flow.reply }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <small>
                                            <strong>{{
                                                $store.state.language.agent
                                                    .list_column.industry
                                            }}</strong>
                                        </small>
                                        <div style="color: #666;">
                                            {{ d.industry }}
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <small>
                                            <strong>{{
                                                $store.state.language.agent
                                                    .list_column.url
                                            }}</strong>
                                        </small>
                                        <div>
                                            <a target="_blank" :href="d.url">{{
                                                d.url
                                            }}</a>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <small>
                                            <strong>
                                                {{
                                                    $store.state.language.agent
                                                        .list_column
                                                        .machine_install
                                                }}
                                            </strong>
                                        </small>
                                        <div style="color: #666;">
                                            {{ d.machine_install }}
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <small>
                                            <strong>
                                                {{
                                                    $store.state.language.agent
                                                        .list_column.contact
                                                }}
                                            </strong>
                                        </small>
                                        <div style="color: #666;">
                                            {{ d.contact }}
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <small>
                                            <strong>
                                                {{
                                                    $store.state.language.agent
                                                        .list_column.unit
                                                }}
                                            </strong>
                                        </small>
                                        <div style="color: #666;">
                                            {{ d.unit }}
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <small>
                                            <strong>
                                                {{
                                                    $store.state.language.agent
                                                        .list_column.rank
                                                }}
                                            </strong>
                                        </small>
                                        <div style="color: #666;">
                                            {{ d.rank }}
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <small>
                                            <strong>
                                                {{
                                                    $store.state.language.agent
                                                        .list_column.files
                                                }}
                                            </strong>
                                        </small>
                                        <div class="row">
                                            <div
                                                class="col-md-3"
                                                v-show="d.files.length == 0"
                                            >
                                                -
                                            </div>
                                            <div
                                                class="col-md-3"
                                                v-for="df in d.files"
                                                :key="df"
                                            >
                                                <img
                                                    :src="df"
                                                    style="width: 100%;"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </transition>
                </tbody>
                <tbody v-show="dataFilterList.length == 0">
                    <tr>
                        <td colspan="6">
                            {{
                                init
                                    ? $store.state.language.agent.list_column
                                          .no_data
                                    : $store.state.language.agent.list_column
                                          .loading
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            init: false,
            dataList: [],
            select: {
                status: "all",
                company: ""
            },
        };
    },
    computed: {
        dataFilterList() {
            let list = this.dataList;
            if (this.select.status !== "all") {
                list = list.filter(d => {
                    const status = Number(d.status);
                    if (this.select.status === "pass") return d.flow_status === "pass" && status < 990;
                    if (this.select.status === "send") return d.flow_status === "send";
                    if (this.select.status === "expire") return d.flow_status !== "reject" && status >= 990;
                    if (this.select.status === "reject") return d.flow_status === "reject";
                    return true;
                });
            }
            if (this.select.company) {
                const key = this.select.company.toLowerCase();
                list = list.filter(d => String(d.company_name || "").toLowerCase().includes(key));
            }
            return list;
        }
    },
    mounted() {
        let vue = this;
        vue.$store
            .dispatch("post_form", {
                payload: { url: "/api/index.php?act=list" }
            })
            .then(res => {
                vue.dataList = res.data.dataList.map(item => {
                    item.files = JSON.parse(item.files);
                    item.show_detail = false;
                    //
                    item.flow_data =
                        item.flow_data != "" ? JSON.parse(item.flow_data) : [];
                    item.flow_var =
                        item.flow_var != "" ? JSON.parse(item.flow_var) : [];
                    item.flow_extra = "";
                    item.last_flow = item.flow_data[item.flow_data.length - 1];
                    return item;
                });
                vue.init = true;
            });
    }
};
</script>
